<template>
  <div style="position: relative;">
    <el-form ref="workstationFilter" :model="workstationList" :size="defaultFormItemSize"
             label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="工作站名称" prop="formFilter.name">
          <el-input class="filter-item" v-model="workstationList.formFilter.name"
                    :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="位置" prop="formFilter.location">
          <el-input class="filter-item" v-model="workstationList.formFilter.location"
                    :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="分管领导" prop="formFilter.leader">
          <el-input class="filter-item" v-model="workstationList.formFilter.leader"
                    :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetWorkstation">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshWorkstation(true)">查询</el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('workstation:all')"
                   @click="handleAdd">
          新增
        </el-button>
        <el-button slot="operator" type="success" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('workstation:all')"
                   @click="handleImport">
          导入
        </el-button>
      </filter-box>
    </el-form>

      <!-- 列表区 -->
      <div class="table-area">
        <el-table ref="workstation" :data="workstationList.Workstation.impl.dataList" :size="defaultFormItemSize" @sort-change="workstationList.Workstation.impl.onSortChange"
                  header-cell-class-name="table-header-gray"
                  highlight-current-row @current-change="workstationList.Workstation.impl.currentRowChange"
                  v-loading="workstationList.Workstation.impl.loading"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="workstationList.Workstation.impl.getTableIndex" />
          <el-table-column label="工作站名称" prop="name" sortable="custom" width="200">
          </el-table-column>
          <el-table-column label="位置" prop="location" width="300">
          </el-table-column>
          <el-table-column label="分管领导" prop="leader" width="150">
          </el-table-column>
          <el-table-column label="联系人" prop="contactPerson" width="120">
          </el-table-column>
          <el-table-column label="联系电话" prop="contactPhone" width="150">
          </el-table-column>
          <el-table-column label="类型" prop="type" width="120">
          </el-table-column>
          <el-table-column label="经度" prop="longitude" width="120">
          </el-table-column>
          <el-table-column label="纬度" prop="latitude" width="120">
          </el-table-column>
          <el-table-column label="创建时间" prop="createTime" sortable="custom" width="180">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.createTime, 'day')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="150px">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button type="danger" size="small" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="workstationList.Workstation.impl.totalCount"
            :current-page="workstationList.Workstation.impl.currentPage"
            :page-size="workstationList.Workstation.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="workstationList.Workstation.impl.onCurrentPageChange"
            @size-change="workstationList.Workstation.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </div>

    <!-- 编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <workstation-form
        ref="workstationForm"
        :workstation="dialogWorkstation"
        :edit-mode="isEditMode"
        @save="handleSave"
        @cancel="handleCancel"
      ></workstation-form>
    </el-dialog>

    <!-- 导入弹窗 -->
    <el-dialog title="导入工作站信息" :visible.sync="workstationList.importDialogVisible" width="500px" :close-on-click-modal="false"
               :close-on-press-escape="false"
    >
      <el-upload
        ref="upload"
        :auto-upload="false"
        :on-change="onFileChange"
        :file-list="workstationList.fileList"
        accept=".xlsx,.xls"
        drag
        :limit="1"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">仅支持xlsx/xls格式文件，且不超过10MB</div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button :size="defaultFormItemSize" @click="workstationList.importDialogVisible = false">取消</el-button>
        <el-button type="primary" :size="defaultFormItemSize" :loading="workstationList.isImporting" @click="onImportSubmitClick">确定导入</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { TableWidget } from '@/utils/widget.js';
import WorkstationForm from './workstationForm.vue';
import { WorkstationController } from '@/api';
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
import { findItemFromList } from '@/utils';

export default {
  name: 'WorkstationList',
  components: {
    WorkstationForm
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      defaultFormItemSize: 'small',
      // 工作站列表
      workstationList: {
        formFilter: {
          name: undefined,
          location: undefined,
          leader: undefined
        },
        formFilterCopy: {
          name: undefined,
          location: undefined,
          leader: undefined
        },
        Workstation: {
          impl: new TableWidget(this.loadWorkstationWidgetData, this.loadWorkstationVerify, true, true)
        },
        importDialogVisible: false,
        isImporting: false,
        fileList: [],
        isInit: false
      },
      // 弹窗
      dialogVisible: false,
      dialogTitle: '',
      isEditMode: false,
      dialogWorkstation: {}
    };
  },
  mounted () {
    this.formInit();
  },
  methods: {
    // 重置
    onResetWorkstation () {
      this.$refs.workstationFilter.resetFields();
      this.refreshWorkstation(true);
    },

    // 加载工作站表格数据
    loadWorkstationWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        workstationDtoFilter: {
          name: this.workstationList.formFilterCopy.name,
          location: this.workstationList.formFilterCopy.location,
          leader: this.workstationList.formFilterCopy.leader
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        WorkstationController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          if (this.workstationList.Workstation.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.workstationList.Workstation.impl.currentRow.id, 'id');
              this.$refs.workstation.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },

    // 验证工作站表格数据
    loadWorkstationVerify (data) {
      return true;
    },

    // 刷新工作站列表
    refreshWorkstation (resetPage) {
      this.workstationList.formFilterCopy = JSON.parse(JSON.stringify(this.workstationList.formFilter));
      if (resetPage) {
        this.workstationList.Workstation.impl.refreshTable(true, 1);
      } else {
        this.workstationList.Workstation.impl.refreshTable();
      }
      if (!this.workstationList.isInit) {
        // 初始化下拉数据
      }
      this.workstationList.isInit = true;
    },

    onResume () {
      this.refreshWorkstation();
    },
    formInit () {
      this.refreshWorkstation();
    },
    // 新增
    handleAdd () {
      this.isEditMode = false;
      this.dialogTitle = '新增工作站';
      this.dialogWorkstation = {};
      this.dialogVisible = true;
    },

    // 编辑
    handleEdit (row) {
      this.isEditMode = true;
      this.dialogTitle = '编辑工作站';
      this.dialogWorkstation = Object.assign({}, row);
      this.dialogVisible = true;
    },

    // 删除
    handleDelete (row) {
      this.$confirm('确定要删除该工作站吗？', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        WorkstationController.delete(this, { id: row.id }).then(res => {
          this.$message.success('删除成功');
          this.refreshWorkstation(false);
        }).catch(e => {
          this.$message.error('删除失败');
        });
      }).catch(() => {
        // 取消删除
      });
    },

    // 导入
    handleImport () {
      this.workstationList.fileList = [];
      this.workstationList.importDialogVisible = true;
    },

    onFileChange (file, fileList) {
      this.workstationList.fileList = fileList.slice(-1);
    },

    onImportSubmitClick () {
      if (this.workstationList.fileList.length === 0) {
        this.$message.warning('请选择要导入的文件');
        return;
      }
      this.workstationList.isImporting = true;
      let formData = new FormData();
      formData.append('file', this.workstationList.fileList[0].raw);
      WorkstationController.importData(this, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        if (res.success) {
          let data = res.data;
          this.$message.success(`导入完成：成功${data.successCount}条，失败${data.failCount}条`);
          if (data.failMessages && data.failMessages.length > 0) {
            this.$alert(data.failMessages.join('<br/>'), '导入失败详情', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定'
            });
          }
          this.workstationList.importDialogVisible = false;
          this.refreshWorkstation(true);
        } else {
          this.$message.error(res.message);
        }
      }).catch(e => {
        this.$message.error('导入失败');
      }).finally(() => {
        this.workstationList.isImporting = false;
      });
    },

    // 保存
    handleSave () {
      this.dialogVisible = false;
      this.refreshWorkstation();
    },
    // 取消
    handleCancel () {
      this.dialogVisible = false;
    }
  }
};
</script>

<style scoped>
.workstation-list-page {
  padding: 10px;
}

.search-area {
  margin-bottom: 20px;
}

.table-area {
  margin-top: 20px;
}
</style>
